import { render, staticRenderFns } from "./LihatPermohonan.vue?vue&type=template&id=507568be"
import script from "./LihatPermohonan.vue?vue&type=script&lang=js"
export * from "./LihatPermohonan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports